import React from "react";
import Input from './Form/Input';
import Next from './Next';
import { Transition } from 'react-transition-group';
import { transitionStyles, duration, defaultStyle } from './constants';
const axios = require('axios');


export default class LaunchConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      formSections: [
        {
          secName: "Select your preferred service",
          questions: [
            {
              q: "What is the purpose of your search?",
              required: true,
              name: 'purpose',
              type: 'buttons',
              options: ['one_or_more','iod','ion'],
              buttonsClass: "w-100 mb-3 text-start",
              output: [
                'I need to launch one or more satellites',
                'I need to test a technology in orbit (IOD)',
                'I need a dedicated ION'
              ]
            },
            {
              q: "How many satellites?",
              required: true,
              name: 'number_of_satellites',
              type: 'number',
              value: "",
              path: [{purpose: ['one_or_more','iod']}],
              className: "col-md-6"
            },
            {
              q: "What kind of satellite(s)?",
              required: true,
              name: 'units',
              type: 'select',
              options: ['','1U','2U','3U','4U','6U','8U','12U','16U','Microsat up to 180 kg of mass'],
              output: ['Select size'],
              value: "",
              help: "In case of IODs, select the form factor in which your experiment can be contained",
              className: "col-md-6",
              path: [{purpose: ['one_or_more','iod']}],
            },
            {
              q: "What is the total mass?",
              required: true,
              name: 'mass',
              type: 'select',
              value: "",
              output: ['Select mass'],
              options: ['','0-1kg','1-3kg','3-6kg','6-9kg','9-15kg','15-20kg','20-24kg','24-32kg','32-40kg','40-180kg'],
              path: [{purpose: ['one_or_more','iod']}],
              className: "col-md-6"
            },
            {
              q: "Altitude",
              required: true,
              name: 'altitude',
              type: 'number',
              value: "",
              help: "in Kms",
              path: [{purpose: ['one_or_more','iod']}],
              className: "col-md-6"
            },
            /*{
              q: "Minimum Altitude",
              required: true,
              name: 'altitude_min',
              type: 'number',
              value: "",
              help: "in Kms",
              path: [{purpose: ['one_or_more','iod']}],
              className: "col-md-6"
            },
            {
              q: "Maximum Altitude",
              required: true,
              name: 'altitude_max',
              type: 'number',
              value: "",
              help: "in Kms",
              path: [{purpose: ['one_or_more','iod']}],
              className: "col-md-6"
            },*/
            {
              q: "Tell us more about your project (optional)",
              required: false,
              description: "Let us know your mission needs and we’ll come back to you with a tailored proposal.",
              name: 'notes',
              type: 'textarea',
              value: "",
              placeholder: "Your notes here...",
              path: [{purpose: ['ion']}],
              /*mainCntClass: "row",
              btnCntClass: "col-md-6",
              buttonsClass: "w-100 mb-3"*/
            },
            {
              q: "Agreement",
              required: true,
              description: false,
              name: 'agreement',
              type: 'switch',
              value: false,
              help: <>Turn this switch on to accept the <a href="#">Terms and Conditions</a> of this service and our <a href="#">Privacy policy</a>.</>,
              path: [{purpose: ['ion']}]
            },
            {
              q: "Select the destination of your deployment",
              required: true,
              name: 'destination',
              type: 'buttons',
              options: ['SSO', 'LEO'],
              value: "",
              mainCntClass: "row",
              btnCntClass: "col-md-6",
              buttonsClass: "w-100 mb-3",
              path: [{purpose: ['one_or_more','iod']}],
            },
            {
              q: "What inclination does your project need*",
              required: true,
              name: 'incl',
              type: 'select',
              options: ['', '90-70', '7-50','50-30','30-0'],
              output: ['Select inclination','Between 90° and 70°','Between 70° and 50°','Between 50° and 30°','Between 30° and 0°'],
              value: "",
              help: "* = In degrees. (i.e. 30)",
              path: [{purpose: ['one_or_more','iod'], destination: ['LEO']}]
            },
            {
              q: "LTDN",
              required: true,
              name: 'ltanltdn',
              type: 'select',
              options: [
                '', 'any',
                '00:00am','00:30am',
                '01:00am','01:30am',
                '02:00am','02:30am',
                '03:00am','03:30am',
                '04:00am','04:30am',
                '05:00am','05:30am',
                '06:00am','06:30am',
                '07:00am','07:30am',
                '08:00am','08:30am',
                '09:00am','09:30am',
                '10:00am','10:30am',
                '11:00am','11:30am',
                '12:00pm','12:30pm',
                '01:00pm','01:30pm',
                '02:00pm','02:30pm',
                '03:00pm','03:30pm',
                '04:00pm','04:30pm',
                '05:00pm','05:30pm',
                '06:00pm','06:30pm',
                '07:00pm','07:30pm',
                '08:00pm','08:30pm',
                '09:00pm','09:30pm',
                '10:00pm','10:30pm',
                '11:00pm','11:30pm'],
              output: [
                'Select', 'Any',
                '00:00am [compatible with LTAN 12:00 pm]','00:30am',
                '01:00am','01:30am',
                '02:00am','02:30am',
                '03:00am','03:30am',
                '04:00am','04:30am',
                '05:00am','05:30am',
                '06:00am','06:30am',
                '07:00am','07:30am',
                '08:00am','08:30am',
                '09:00am','09:30am',
                '10:00am','10:30am',
                '11:00am','11:30am',
                '12:00pm','12:30pm',
                '01:00pm','01:30pm',
                '02:00pm','02:30pm',
                '03:00pm','03:30pm',
                '04:00pm','04:30pm',
                '05:00pm','05:30pm',
                '06:00pm','06:30pm',
                '07:00pm','07:30pm',
                '08:00pm','08:30pm',
                '09:00pm','09:30pm',
                '10:00pm','10:30pm',
                '11:00pm','11:30pm'],
              value: "",
              path: [{purpose: ['one_or_more','iod'], destination: ['SSO']}]
            },
            {
              q: "Tell us more about your project (optional)",
              description: "",
              name: 'notes',
              type: 'textarea',
              value: "",
              placeholder: "Your notes here...",
              path: [{purpose: ['one_or_more'], destination: ['SSO','LEO']}],
              /*mainCntClass: "row",
              btnCntClass: "col-md-6",
              buttonsClass: "w-100 mb-3"*/
            },
            {
              q: "Tell us more about your project (optional)",
              description: "Let us know about your basic mission requirements and someone from our team will get in touch with you shortly!",
              name: 'notes',
              type: 'textarea',
              value: "",
              placeholder: "Your notes here...",
              path: [{purpose: ['iod']}],
              /*mainCntClass: "row",
              btnCntClass: "col-md-6",
              buttonsClass: "w-100 mb-3"*/
            }
          ]
        }
      ],
      formData: {...this.props.values}
    };
  }


  getLaunches = async () => {
    /*try{
      const response = await axios.get('http://mpg.19d.mywebsitetransfer.com/launches/.json');
      this.setState({launches: response.data.launches })
    }catch(error) {
      return [];
    }*/

  }

  componentDidMount() {
    setTimeout(() => {
      let top = document.getElementById("launchInfo").getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top - 60,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  }

  onSubmit(e) {
    e.preventDefault()
  }

  next = () => {
    this.cb({field: 'formReady', value: true})
  }


  renderHead = () =>{
    const formSections = this.state.formSections;
    const sections = this.filterPath(formSections);
    let head = sections.map((section, i) => {
      let e = i +1;
      return(
        <div key={'tab'+i} className="nav-item">
          {(i != 0) &&
            <div className="line"></div>
          }
          <div className="nav-link">
            <span className="nav-label">{section.secName}</span>
          </div>
        </div>
      )
    })
    return head;
  }

  filterPath = (arg, required = false) => {
    if(required)
      arg = arg.filter(qu => { if(qu.required == true) return true; })
    arg = arg.filter(qu => {
      if(!qu.hasOwnProperty('path'))
        return true;
      let path = qu.path;
      let ex = true;
      path.map(cond => {
        Object.keys(cond).map((key) => {
          let condVals = cond[key];
          if(this.state.formData.hasOwnProperty(key)){
            if(condVals.filter(cv => this.state.formData[key].includes(cv)).length == 0)
              ex = false;
          }else{
              ex = false;
          }
        });
      })
      return ex;
    })
    return arg;
  }

  renderBody = () =>{
    const formSections = this.state.formSections;
    const sections = this.filterPath(formSections);
    let body = sections.map((section, i) => {
      let e = i + 1;
      const view = (this.state.step == i);
      let questions = this.filterPath(section.questions);
      let required = this.filterPath(section.questions, true);
      let answeredQuestions = this.filterPath(section.questions, true).filter(qu => {
        let ex = false;
        let key = qu.name;
        if(
          (!this.state.formData.hasOwnProperty(key))||
          (!qu.required)
        )
          ex = false;
        let val = this.state.formData[key];
        if(val)
          ex = true;
        return ex;
      })
      return(
        <div key={e}>
          <div className="row">
            {
              questions.map(({...qu},f) => {
                let qq = JSON.parse(JSON.stringify(qu));
                let quClass = qq.className;
                if(this.state.formData.hasOwnProperty(qu.name))
                  qu.value = this.state.formData[qu.name];
                delete qu.className;
                return(
                  <Transition key={"qu" + qu.name} in={true} timeout={duration}>
                    {state => (
                       <div className={quClass} style={{
                         ...defaultStyle,
                         ...transitionStyles[state]
                       }}>
                         <div className="mb-5">
                           <div className="question">{qu.q}</div>
                           <Input {...qu} key={"i" + qu.name} callback={this.cb} label={null} />
                         </div>
                       </div>
                    )}
                  </Transition>
                )
              })
            }
          </div>

          {(
            (this.state.formData.purpose != 'ion')&&
            (!this.state.formData.formReady)
           )&&
            <>
              {((answeredQuestions.length >= required.length)&&(this.state.step <= sections.length)) ?
                (<Next callback={this.next} />)
                :
                (<Next
                  text="Confirm and submit"
                  btnClass="btn btn-success w-100 text-center"
                  disabled
                />)
              }
            </>
          }
       </div>
    )});
    return body;
  }


  cb = (params) => {
    const n = { [params.field]: params.value };
    this.setState({formData : {...this.state.formData, ...n}});
    this.props.callback(params);
  }


  render() {
    const formSections = this.filterPath(this.state.formSections);
    return (
      <div id="launch-sec">


            {this.renderBody()}


      </div>
    );
  }
}
